import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { StudentPracticeSession } from '@ts-core/modules/practice/types';
import {
  getStudentPracticeSessionQuery,
  GetStudentPracticeSessionQueryResult,
  GetStudentPracticeSessionQueryVariables,
} from '../graphql/queries/getStudentPracticeSessionQuery';

type StudentPracticeSessionHookResult = DataFetcherHookResult<StudentPracticeSession, 'studentPracticeSession'>;

interface StudentPracticeSessionHookInput {
  courseId: string;
  studentId: string;
  practiceSessionId: string;
}

export default function useStudentPracticeSession(input: StudentPracticeSessionHookInput): StudentPracticeSessionHookResult {
  const { courseId, practiceSessionId, studentId } = input;
  const { data, loading, error } = useQuery<GetStudentPracticeSessionQueryResult, GetStudentPracticeSessionQueryVariables>(
    getStudentPracticeSessionQuery,
    { variables: { courseId, practiceSessionId, studentId } }
  );

  return { loading, error: getErrorMessage({ error }), studentPracticeSession: data?.studentPracticeSession };
}
